export default "__VITE_ASSET__DnbxU28R__"